import React from "react";

const InputSkeleton = () => {
  return <div className="h-12 w-full rounded-md bg-gray-300"></div>;
};

export default InputSkeleton;
